import { Container } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import {
    StyledFooter,
    Copyright,
    FooterNavRow,
    FooterNavCol,
    StyledFooterInner,
    SocialLinks,
    StyledFooterBottom
} from './styles/Footer.styled'
import moment from 'moment'

interface Item {
    title: string
    links: NavLink[]
}

interface NavLink {
    name: string
    url: string
    cnOnly?: boolean
}

const Footer = () => {
    const { t } = useTranslation()

    const nav: Item[] = [
        // {
        //     title: 'About Us',
        //     links: [
        //         { name: t('About Us'), url: 'https://www.eiqhome.com/utilities/about-us', },
        //         { name: t('Contact Us'), url: 'https://www.eiqhome.com/utilities/contact-us' },
        //         { name: 'Our Services', url: 'https://www.eiqhome.com/utilities/our-services' },
        //         { name: 'Press Release', url: 'https://www.eiqhome.com/utilities/category/press-release' }
        //     ],
        // },
        {
            title: 'Company',
            links: [
                { name: t('About Us'), url: '/about_us' },
            ],
        },
        {
            title: 'Legal & Policies',
            links: [
                { name: t('Terms of Service'), url: '/terms-of-service' },
                { name: t('Privacy Policy'), url: '/privacy_policy' },
            ],
        },
        {
            title: 'Support & Contact',
            links: [
                { name: t('Contact Us'), url: '/contact-us' },
                { name: t('FAQs'), url: '/faqs' },
            ],
        },
        {
            title:'Developers',
            links:[
                { name: t('Documentation'), url: 'https://documenter.getpostman.com/view/4831254/SzKYPH3c'}
            ]
        }
    ]

    return (
        <StyledFooter>
            <Container>
                <StyledFooterInner>
                    <FooterNavRow>
                        <FooterNavCol><img src="/images/logo.png" alt="" /></FooterNavCol>
                        {nav.map((val, idx) => (
                            <FooterNavCol key={idx}>
                                <h6>{val.title}</h6>
                                {val.links.map((item, itemIdx) => {
                                    return (
                                        <div key={itemIdx}>
                                            <a href={item.url} rel="noreferrer">
                                                {item.name}
                                            </a>
                                        </div>
                                    )
                                })}
                            </FooterNavCol>
                        ))}
                        <div style={{textAlign:'center'}}>
                            {/* <SocialLinks>
                                <a href="https://twitter.com/EiQhome" target="_blank" rel="noreferrer"><img src="/images/ft-social-link-tw.png" width="36" height="36" alt="" /></a>
                                <a href="https://fb.me/EIQhome" target="_blank" rel="noreferrer"><img src="/images/ft-social-link-fb.png" width="36" height="36" alt="" /></a>
                                <a href="https://www.linkedin.com/company/eiqhome" target="_blank" rel="noreferrer"><img src="/images/ft-social-link-in.png" width="36" height="36" alt="" /></a>
                                <a href="https://www.youtube.com/channel/UClBzvdtbP9BQ3B2eRrC7y6g" target="_blank" rel="noreferrer"><img src="/images/ft-social-link-youtube.png" width="36" height="36" alt="" /></a>
                            </SocialLinks> */}
                            <a href="https://www.eiqdigital.com/" target="_blank"><img src="/images/powered_by_eiqdigital_dark.png" width="220" alt="" /></a>
                            <Copyright>
                                {moment().format('YYYY')} © EIQdigital. All Rights Reserved.<br />
                                TX #BR191039<br />
                                <a
                                    href="https://www.eiqdigital.com/PUCT_Required_Disclosure"
                                    target="_blank"
                                    rel="noreferrer">
                                    PUCT Required Disclosure
                                </a>
                            </Copyright>
                        </div>
                    </FooterNavRow>
                </StyledFooterInner>
                <StyledFooterBottom>
                </StyledFooterBottom>
            </Container>
        </StyledFooter>
    )
}

export default Footer
